import {
  ArticlePageQuery,
  CategoryPageQuery,
  HomePageQuery,
} from '@elevio-kb/queries/dist/types';
import { IState } from '../reducers';
import { Maybe } from '../utils/types';
import { FetchingStatus as PageFetchingStatus } from '../reducers/page';

/*
 *  Fetching Status
 */

export type FetchingStatus = PageFetchingStatus | 'not-started' | 'is-fetching';

export function articlePageFetchingStatus(
  state: IState,
  articleId: string
): FetchingStatus {
  const currentPage = state.page.currentPage;
  const loadingPage = state.page.loadingPage;

  if (
    currentPage &&
    currentPage.pageType === 'article' &&
    currentPage.articleId === articleId
  ) {
    return currentPage.status;
  }

  if (
    loadingPage &&
    loadingPage.pageType === 'article' &&
    loadingPage.articleId === articleId
  ) {
    return 'is-fetching';
  }
  return 'not-started';
}

export function categoryPageFetchingStatus(
  state: IState,
  categoryId: string
): FetchingStatus {
  const currentPage = state.page.currentPage;
  const loadingPage = state.page.loadingPage;

  if (
    currentPage &&
    currentPage.pageType === 'category' &&
    currentPage.categoryId === categoryId
  ) {
    return currentPage.status;
  }

  if (
    loadingPage &&
    loadingPage.pageType === 'category' &&
    loadingPage.categoryId === categoryId
  ) {
    return 'is-fetching';
  }
  return 'not-started';
}

export function searchPageFetchingStatus(
  state: IState,
  _searchTerm: string
): FetchingStatus {
  const currentPage = state.page.currentPage;
  const loadingPage = state.page.loadingPage;

  if (
    currentPage &&
    currentPage.pageType === 'search' &&
    currentPage.searchTerm === _searchTerm
  ) {
    return currentPage.status;
  }

  if (
    loadingPage &&
    loadingPage.pageType === 'search' &&
    loadingPage.searchTerm === _searchTerm
  ) {
    return 'is-fetching';
  }
  return 'not-started';
}

export function homePageFetchingStatus(state: IState): FetchingStatus {
  const currentPage = state.page.currentPage;
  const loadingPage = state.page.loadingPage;

  if (currentPage && currentPage.pageType === 'home') {
    return currentPage.status;
  }

  if (loadingPage && loadingPage.pageType === 'home') {
    return 'is-fetching';
  }
  return 'not-started';
}

export function getArticlePageData(
  state: IState,
  articleId: string
): Maybe<ArticlePageQuery> {
  const currentPage = state.page.currentPage;

  if (
    currentPage &&
    currentPage.pageType === 'article' &&
    currentPage.articleId === articleId
  ) {
    return currentPage.data;
  }

  return null;
}

export function getCategoryPageData(
  state: IState,
  categoryId: string
): CategoryPageQuery | null {
  const currentPage = state.page.currentPage;

  if (
    currentPage &&
    currentPage.pageType === 'category' &&
    currentPage.categoryId === categoryId
  ) {
    return currentPage.data;
  }

  return null;
}

export function getHomePageData(state: IState): HomePageQuery | null {
  const currentPage = state.page.currentPage;

  if (currentPage && currentPage.pageType === 'home') {
    return currentPage.data;
  }

  return null;
}

export function searchFetchingStatus(
  state: IState,
  query: string,
  page: number
): FetchingStatus {
  // Do we have it already?
  if (
    state.search.searchedTerm === query &&
    state.search.currentPage === page
  ) {
    return 'has-fetched';
  }

  if (
    state.search.searchedTerm === query &&
    state.search.currentPage - 1 === page &&
    state.search.isFetching
  ) {
    return 'is-fetching';
  }

  return 'not-started';
}

export function searchTerm(state: IState): string {
  if (!state.page.currentPage) return '';
  if (state.page.currentPage.pageType !== 'search') return '';
  return state.page.currentPage.searchTerm;
}
